import { IToken, CstNode } from 'chevrotain';
import { parser } from './grammar';
import { visitor } from './cst-visitor';
import { ExerciseDocument } from '../ast/document';
import { ParseError } from '../errors';

export { parser };

/**
 * Parse DSL tokens into CST
 */
export function parse(tokens: IToken[]) {
  parser.input = tokens;
  const cst = parser.exerciseDocument();
  
  if (parser.errors.length > 0) {
    throw new ParseError(parser.errors);
  }
  
  return cst;
}

/**
 * Parse DSL tokens into CST (safe version - returns errors instead of throwing)
 */
export function parseSafe(tokens: IToken[]) {
  try {
    return { success: true as const, cst: parse(tokens) };
  } catch (error) {
    return { success: false as const, error };
  }
}

/**
 * Transform CST to AST
 */
export function toAST(cst: CstNode): ExerciseDocument {
  return visitor.visit(cst);
}
